"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newBathroom = void 0;
const newBathroom = (bathroomNumber, property) => ({
    property,
    bathroom_number: bathroomNumber,
    bath_type: 'none',
    shower_type: 'walk in',
    private_access: true,
    accessible: false,
    ensuite: false,
    toilet_type: 'standard'
});
exports.newBathroom = newBathroom;
//# sourceMappingURL=helper.js.map